var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-calendar overflow-hidden border" },
    [
      _c(
        "div",
        { staticClass: "row no-gutters" },
        [
          _c(
            "div",
            {
              staticClass:
                "col app-calendar-sidebar flex-grow-0 overflow-hidden d-flex flex-column",
              class: { show: _vm.isCalendarOverlaySidebarActive }
            },
            [
              _c("calendar-sidebar", {
                attrs: {
                  scheduleAuthors: _vm.calendarAuthors,
                  "is-event-handler-sidebar-active":
                    _vm.isEventHandlerSidebarActive
                },
                on: {
                  "filter:author": _vm.filterAuthor,
                  "update:isEventHandlerSidebarActive": function($event) {
                    _vm.isEventHandlerSidebarActive = $event
                  },
                  "update:is-event-handler-sidebar-active": function($event) {
                    _vm.isEventHandlerSidebarActive = $event
                  }
                }
              })
            ],
            1
          ),
          _c("div", { staticClass: "col position-relative" }, [
            _c(
              "div",
              { staticClass: "card shadow-none border-0 mb-0 rounded-0" },
              [
                _c("div", { staticClass: "card-body pb-0" }, [
                  _c(
                    "div",
                    { staticClass: "position-relative" },
                    [
                      _vm.isLoading
                        ? _c(
                            "div",
                            { staticClass: "calendar-loading-discrete" },
                            [_vm._m(0)]
                          )
                        : _vm._e(),
                      _c("full-calendar", {
                        ref: "refCalendar",
                        staticClass: "full-calendar calendar-with-legend",
                        attrs: { options: _vm.calendarOptions }
                      }),
                      _vm._m(1)
                    ],
                    1
                  )
                ])
              ]
            )
          ]),
          _c("div", {
            staticClass: "body-content-overlay",
            class: { show: _vm.isCalendarOverlaySidebarActive },
            on: {
              click: function($event) {
                _vm.isCalendarOverlaySidebarActive = false
              }
            }
          }),
          _c("calendar-event-handler", {
            key: _vm.handlerRenderKey,
            attrs: {
              event: Object.assign(
                {},
                { organizationalUnitsList: [] },
                _vm.event
              ),
              "clear-event-data": _vm.clearEventData
            },
            on: {
              "remove-event": _vm.promptRemoveEvent,
              "add-event": _vm.addEvent,
              "update-event": _vm.tryUpdateEvent,
              "change-confirmation": _vm.refetchEvents,
              "update-suggestion": _vm.updateLocalSuggestionData
            },
            model: {
              value: _vm.isEventHandlerSidebarActive,
              callback: function($$v) {
                _vm.isEventHandlerSidebarActive = $$v
              },
              expression: "isEventHandlerSidebarActive"
            }
          })
        ],
        1
      ),
      _c("b-modal", {
        attrs: {
          "ok-disabled": _vm.isEmpty(_vm.exclusionJustification),
          title: "Confirmar exclusão",
          "ok-only": "",
          id: "delete-justification"
        },
        on: {
          ok: function($event) {
            return _vm.removeEvent(_vm.eventToDelete)
          }
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function() {
              return [
                _c(
                  "b-form",
                  [
                    _c("p", { staticClass: "pb-8" }, [
                      _vm._v(
                        "Justifique o motivo de exclusão deste agendamento."
                      )
                    ]),
                    _c("b-form-textarea", {
                      attrs: {
                        state: !_vm.isEmpty(_vm.exclusionJustification)
                      },
                      model: {
                        value: _vm.exclusionJustification,
                        callback: function($$v) {
                          _vm.exclusionJustification = $$v
                        },
                        expression: "exclusionJustification"
                      }
                    })
                  ],
                  1
                )
              ]
            },
            proxy: true
          },
          {
            key: "modal-ok",
            fn: function() {
              return [_vm._v(" Confirmar ")]
            },
            proxy: true
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "d-flex align-items-center" }, [
      _c(
        "div",
        {
          staticClass: "spinner-border spinner-border-sm text-primary mr-2",
          attrs: { role: "status" }
        },
        [_c("span", { staticClass: "sr-only" }, [_vm._v("Carregando...")])]
      ),
      _c("small", { staticClass: "text-muted" }, [_vm._v("Carregando...")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "calendar-legend-overlay" }, [
      _c(
        "div",
        {
          staticClass:
            "d-flex justify-content-center align-items-center flex-wrap"
        },
        [
          _c(
            "span",
            {
              staticClass: "legend-badge mr-2",
              staticStyle: {
                background: "rgba(115, 103, 240, 0.15)",
                color: "#7367f0",
                padding: "2px 6px",
                "border-radius": "10px",
                "font-size": "0.7rem",
                "font-weight": "600"
              }
            },
            [_vm._v(" ● Reunião ")]
          ),
          _c(
            "span",
            {
              staticClass: "legend-badge mr-2",
              staticStyle: {
                background: "rgba(40, 199, 111, 0.15)",
                color: "#28c76f",
                padding: "2px 6px",
                "border-radius": "10px",
                "font-size": "0.7rem",
                "font-weight": "600"
              }
            },
            [_vm._v(" ● Evento ")]
          ),
          _c(
            "span",
            {
              staticClass: "legend-badge",
              staticStyle: {
                background: "rgba(255, 159, 67, 0.15)",
                color: "#ff9f43",
                padding: "2px 6px",
                "border-radius": "10px",
                "font-size": "0.7rem",
                "font-weight": "600"
              }
            },
            [_vm._v(" ● Lembrete ")]
          )
        ]
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }